<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>Add Family Account</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
      <ion-toolbar>
        <ion-searchbar
          id="searchbar"
          type="text"
          @ionInput="getItems($event)"
        ></ion-searchbar>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-list v-if="patients.length > 0">
        <ion-item
          text-center
          @click="
            addFamilyAccount(
              patient.id +
                '~' +
                patient.patientName +
                '~' +
                patient.patientLocation +
                '~' +
                patient.patientWebId
            )
          "
          lines="{full}"
          detail="{true}"
          v-for="patient in patients"
          :key="patient.id"
        >
          <ion-label>{{ patient.patientName }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>
<script>
import getPatientsMixin from "../../mixins/getPatientsMixin";
export default {
  mixins: [getPatientsMixin],
  methods: {
    addFamilyAccount(item) {
      let self = this;
      // eslint-disable-next-line no-console
      console.log(item);
      //var values = item.split("~");
      //this.$store.state.location = values[2];
      //this.$store.state.userName = "None";
      //this.$store.state.userId = values[3];

      self.$router.push({
        name: "addpatientsscreentwo",
        params: { data: item },
      });
    },
  },
};
</script>
<style>
#searchbar {
  width: 80%;
  margin: auto;
}
</style>